import React from 'react'

const FieldGroup = (props) => {
  const { title, value = false, children } = props

  if (!value || value.length === 0) {
    return null
  }

  let content = children

  if (!children) {
    content = value
  }

  return (
    <div className='mb-10'>
      <div className='text-black font-bold mb-3 text-base border-b border-grey pb-1 inline-block'>
        {title}
      </div>

      {!children &&
      value && (
        <div
          className='text-base leading-base text-grey-darkest'
          dangerouslySetInnerHTML={{
            __html: content
          }}
        />
      )}

      {children && (
        <div
          className='text-base leading-base text-grey-darkest'
          children={children}
        />
      )}
    </div>
  )
}

export default FieldGroup
